// =============================================================================================================
// OIDC Connection Hooks
// =============================================================================================================
import { useCallback } from 'react';
import { useStytchCreateOIDCConnection, useStytchUpdateOIDCConnection } from '../../../../services/stytch/client';
export function useCreateOIDCConnection() {
    const createOIDCConnection = useStytchCreateOIDCConnection();
    return useCallback(async (data) => {
        const result = await createOIDCConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [createOIDCConnection]);
}
export function useUpdateOIDCConnection() {
    const updateOIDCConnection = useStytchUpdateOIDCConnection();
    return useCallback(async (data) => {
        const result = await updateOIDCConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                requestId: result.requestId,
                connection: result.connection,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [updateOIDCConnection]);
}
